<template>
  <div class="mask" v-show="show">
    <div class="enlarge-img">
      <div class="close-btn ta_r">
        <img src="./../../assets/img/1565752387029_btn_off_home.png" alt="" srcset="" @click="closeDialogFn()">
      </div>
      <div class="img-box" v-if="item">
        <img :src="item.url" alt="" srcset="">
      </div>
      <div class="enlarge-img-body" v-if="item">
        <h4>{{item.name}}</h4>
        <p>{{item.desc}}</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    show: {
      type: Boolean,
      defalut: false
    },
    item:{
      type: Object,
      defalut: false
    }
  },
  name:'enlargeImg',
  data(){
    return{
    }
  },
  mounted(){
    
  },
  methods:{
    closeDialogFn(){
      this.$emit("isclose", true)
    },
    enlargeImgFn(){
    }
  }
}
</script>

<style lang="less">
.mask{
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.69);
  .enlarge-img{
    position: relative;
    top:20%;
    left: 50%;
    margin-left: -338px;
    width: 676px;
    height: 530px;
    border: 10px solid #fff;
    background: #fff;
    color: #fff;
    &:after{
      z-index: 10001;
      opacity: 0.8;
      position: absolute;
      bottom: 0px;
      left: 0px;
      content: '';
      height: 200px;
      width: 676px;
      background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 3%, rgba(0,0,0,0.10) 17%, #000000 100%);
    }
    .close-btn{
      z-index: 10002;
      position: relative;
      top: -44px;
      right: -44px;
      img{
        width:30px;
      }
    }
    .img-box{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .enlarge-img-body{
      z-index: 10003;
      position: absolute;
      bottom: 16px;
      left: 0px;
      padding: 0 22px;
      h4{
        font-size: 16px;
      }
      p{
        font-size: 12px;
        line-height: 24px;
      }

    }

  }
}
</style>


